import { useWaitlistModal } from '../waitlist/WaitlistModal';

const LandingCtaSection = () => {
  const { openWaitlistModal } = useWaitlistModal();

  return (
    <section className="bl-landing-cta" id="early-access">
      <div className="bl-landing-cta__box">
        <div className="bl-landing-cta__glow" aria-hidden="true" />
        <h2>Ready to understand your body?</h2>
        <p>
          BodyLytiX is opening full access soon. Join the wish list and be among the first to use the platform as it grows.
        </p>
        <button className="bl-button bl-button--primary" type="button" onClick={openWaitlistModal}>
          Apply to Wish List <i className="fas fa-arrow-right" aria-hidden="true" />
        </button>
      </div>
    </section>
  );
};

export default LandingCtaSection;
